/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NotificationDTO } from '../models/NotificationDTO';
import type { UpdateNotificationDTO } from '../models/UpdateNotificationDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class NotificationControllerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public updateNotification(
        requestBody: UpdateNotificationDTO,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/notifications',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public deleteNotification(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/notifications',
        });
    }
    /**
     * @returns NotificationDTO OK
     * @throws ApiError
     */
    public getActiveNotification(): CancelablePromise<NotificationDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/notifications/active',
        });
    }
}
